module.exports = __webpack_public_path__ + "static/media/pplogo-192-agritech.7b2fe086.png";